import React, { useState } from 'react';
import { Card, Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

const MFAVerification = ({ token, onSuccess }) => {
  const [mfaCode, setMfaCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { verifyMFA } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await verifyMFA(token, mfaCode);
      onSuccess();
    } catch (err) {
      setError(
        err.response?.data?.detail ||
        'Ungültiger MFA-Code. Bitte versuchen Sie es erneut.'
      );
      setMfaCode('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <Row className="justify-content-center mt-5">
        <Col md={6} lg={5}>
          <Card className="shadow">
            <Card.Body className="p-5">
              <div className="text-center mb-4">
                <h2 className="mb-2">Zwei-Faktor-Authentifizierung</h2>
                <p className="text-muted">
                  Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein
                </p>
              </div>

              {error && (
                <Alert variant="danger" dismissible onClose={() => setError('')}>
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-4">
                  <Form.Label>MFA-Code</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="000000"
                    value={mfaCode}
                    onChange={(e) => setMfaCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    required
                    maxLength={6}
                    className="text-center fs-4 letter-spacing-wide"
                    autoFocus
                  />
                  <Form.Text className="text-muted">
                    6-stelliger Code aus Google Authenticator oder einer ähnlichen App
                  </Form.Text>
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 btn-pcs"
                  disabled={loading || mfaCode.length !== 6}
                >
                  {loading ? 'Überprüfung läuft...' : 'Verifizieren'}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MFAVerification;
